// Skins are sent in pieces small enough for every WebRTC data channel.
export const SKIN_CHUNK_ID = '!SKIN';
const HEADER_BYTES = SKIN_CHUNK_ID.length + 5;
const CHUNK_PAYLOAD = 16 * 1024 - HEADER_BYTES;
const MAX_SKIN_BYTES = 4 * 1024 * 1024;

export const isSkinChunk = buffer => buffer.byteLength > HEADER_BYTES
	&& String.fromCharCode(...new Uint8Array(buffer, 0, SKIN_CHUNK_ID.length)) === SKIN_CHUNK_ID;

export const splitSkin = (buffer, transfer) => {
	const count = Math.max(1, Math.ceil(buffer.byteLength / CHUNK_PAYLOAD));
	return Array.from({length: count}, (_, index) => {
		const payload = new Uint8Array(buffer, index * CHUNK_PAYLOAD, Math.min(CHUNK_PAYLOAD, buffer.byteLength - index * CHUNK_PAYLOAD));
		const chunk = new Uint8Array(HEADER_BYTES + payload.byteLength);
		const view = new DataView(chunk.buffer);
		for (let i = 0; i < SKIN_CHUNK_ID.length; i++) chunk[i] = SKIN_CHUNK_ID.charCodeAt(i);
		view.setUint8(SKIN_CHUNK_ID.length, transfer & 255);
		view.setUint16(SKIN_CHUNK_ID.length + 1, index);
		view.setUint16(SKIN_CHUNK_ID.length + 3, count);
		chunk.set(payload, HEADER_BYTES);
		return chunk.buffer;
	});
};

export class SkinAssembler {
	constructor() { this.transfers = new Map(); }
	push(peer, buffer) {
		const view = new DataView(buffer);
		const transfer = view.getUint8(SKIN_CHUNK_ID.length);
		const index = view.getUint16(SKIN_CHUNK_ID.length + 1);
		const count = view.getUint16(SKIN_CHUNK_ID.length + 3);
		if (!count || index >= count || count * CHUNK_PAYLOAD > MAX_SKIN_BYTES) return null;
		let state = this.transfers.get(peer);
		if (!state || state.transfer !== transfer || state.parts.length !== count) {
			state = {transfer, parts: new Array(count), received: 0};
			this.transfers.set(peer, state);
		}
		if (!state.parts[index]) state.received++;
		state.parts[index] = new Uint8Array(buffer, HEADER_BYTES);
		if (state.received < count) return null;
		this.transfers.delete(peer);
		const skin = new Uint8Array(state.parts.reduce((bytes, part) => bytes + part.byteLength, 0));
		let offset = 0;
		for (const part of state.parts) { skin.set(part, offset); offset += part.byteLength; }
		return skin.buffer;
	}
	delete(peer) { this.transfers.delete(peer); }
	clear() { this.transfers.clear(); }
}
